(function () {
  const LINKED_ADD_EVENT_NAME = 'upsell_popup_add_to_cart';
  const LINKED_ADD_SOURCE = 'upsell-popup-linked-product';
  const TRIGGER_EVENT_NAME = 'upsell_popup_opened_by_add';
  const TRIGGER_SOURCE = 'upsell-popup';
  const LISTENER_FLAG = '__customUpsellPopupDatalayerBound';

  if (window[LISTENER_FLAG]) return;
  window[LISTENER_FLAG] = true;

  function toNumber(value, fallback = 0) {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function buildItem(detail = {}) {
    const product = detail.product || {};
    const quantity = toNumber(detail.quantity ?? product.quantity, 1);
    const unitPrice = toNumber(product.price, 0) / 100;

    return {
      item_id: `${detail.variantId || product.variant_id || product.id || ''}`,
      item_name: product.product_title || product.title || '',
      quantity,
      price: unitPrice,
    };
  }

  function pushUpsellEvent(event) {
    const detail = event?.detail || {};
    if (!detail.source) return;

    window.dataLayer = window.dataLayer || [];

    if (detail.source === TRIGGER_SOURCE) {
      window.dataLayer.push({
        event: TRIGGER_EVENT_NAME,
        source: TRIGGER_SOURCE,
        trigger_product_id: `${detail.triggerProductId || detail.product?.product_id || ''}`,
        trigger_variant_id: `${detail.variantId || detail.product?.variant_id || ''}`,
        quantity: toNumber(detail.quantity ?? detail.product?.quantity, 1),
      });
      return;
    }

    if (detail.source === LINKED_ADD_SOURCE) {
      const item = buildItem(detail);
      window.dataLayer.push({
        event: LINKED_ADD_EVENT_NAME,
        source: LINKED_ADD_SOURCE,
        trigger_product_id: `${detail.triggerProductId || ''}`,
        ecommerce: {
          currency: window.Shopify?.currency?.active || null,
          value: item.price * item.quantity,
          items: [item],
        },
      });
    }
  }

  document.addEventListener('product-ajax:added', pushUpsellEvent);
})();
